import { strtrim, strempty, isEuCountry, onLoginSuccess, setAnalyticsIdentity, logUserActivity } from './utils'

function setError(msg) {
    $('#error-message').text(msg)
    $('#error-message').css('display', 'block')
}

window.onload = () => {

    const queryParams = new URLSearchParams(window.location.search)
    const referralId = queryParams.get('referralId') || null

    console.log(`referralId=%O`, referralId)

    let shouldBeGdprCompliant = false

    isEuCountry().then((yes) => {
        if (yes) {
            $('#gdpr').css('display', 'block')
            shouldBeGdprCompliant = true
        }
    })

    $('#create-account-btn').on('click', ev => {
        const formdata = {}
        $('#wf-form-Terms-Conditions').serializeArray().forEach(({ name, value }) => {
            if (name === 'Email') {
                formdata.email = strtrim(value)
            } else if (name === 'Username') {
                formdata.username = strtrim(value)
            } else if (name === 'Password') {
                formdata.password = value
            } else if (name === 'Confirm-password') {
                formdata.password2 = value
            } else if (name === 'Referral-ID') {
                formdata.referralCode = value
            }
        })
        console.log('form: %O', formdata)

        let gdprCheckboxData = {}
        if (shouldBeGdprCompliant) {
            gdprCheckboxData.doReceiveAnnouncements = $('#checkbox').prop('checked')
            gdprCheckboxData.doConfirmPolicy = $('#checkbox-2').prop('checked')
        }

        console.log('gdprCheckboxData: ' + JSON.stringify(gdprCheckboxData))

        if (shouldBeGdprCompliant && !gdprCheckboxData.doConfirmPolicy) {
            setError('Please confirm the gdpr policy.')
            return
        }
        if (strempty(formdata.email)) {
            setError('Please fill out the email.')
            return
        }
        if (strempty(formdata.username)) {
            setError('Please fill out the username.')
            return
        }
        if (strempty(formdata.password)) {
            setError('Please set your password.')
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/users`,
            data: JSON.stringify({ ...formdata, shouldBeGdprCompliant, gdprCheckboxData }),
            dataType: 'json',
            contentType: 'application/json',
            error: (response) => {
                const { code, what, min, max, reason } = response.responseJSON || {}
                console.log('failure response=%O', response.responseJSON)
                console.log('failure code=' + code)
                if (code === 'unauthorized') {
                    setError('Username does not exist or the credentials do not match.')
                } else if (code === 'duplicate') {
                    if (what === 'email') {
                        setError('That email is already used.')
                    } else if (what === 'username') {
                        setError('That username already exists.')
                    }
                } else if (code === 'invalid_username') {
                    if (reason === 'too_short') {
                        setError(`Username must be at least ${min} characters long.`)
                    } else if (reason === 'too_long') {
                        setError(`The username is too long.`)
                    } else {
                        setError(`The username is invalid.`)
                    }
                } else if (code === 'invalid_email') {
                    setError(`That doesn't look like a valid email address.`)
                } else if (code === 'invalid_password') {
                    if (reason === 'too_short') {
                        setError(`Password must be at least ${min} characters long.`)
                    } else if (reason === 'too_long') {
                        setError(`The password is too long.`)
                    } else {
                        setError(`The password is invalid.`)
                    }
                } else {
                    setError(`There was a problem while logging you in. code=${code}`)
                }
            }
        })
        .done(response => {
            const { token, user } = response
            // response: {                
            //   status: 'ok',
            //   token: '...',
            //   user: { createdAt, displayEmail, email, pass }
            // }
            console.log('login response: %O', response)

            try {
                setAnalyticsIdentity(user.urn, user)
                logUserActivity('ACCOUNT_CREATED', user.username, user)
            } catch (error) {
                console.error('Error in Analytics:', error)
            } finally {
                onLoginSuccess(token, user, 'welcome-to-muse')
            }
        })
    })

    if (referralId) {
        const referralIdInput = $('#Referral-ID')
        referralIdInput.val(referralId)
        referralIdInput.on('paste', (ev) => {
            function extractReferralIdIfIsUrl(urlString) {
                try {
                    let url = new URL(urlString)
                    let params = new URLSearchParams(url.search)
                    return params.get('referralId')
                } catch (error) {
                    return null
                }
            }

            const pastedText = ev.originalEvent.clipboardData.getData('text')
            console.log('pastedText=' + pastedText)
            let referralId = extractReferralIdIfIsUrl(pastedText)
            if (referralId != null) {
                referralIdInput.val(referralId)
                ev.preventDefault()
            }
        })
    }

    $("a:contains('Sign in')").click((e) => {
        const queryParams = window.location.search
        e.preventDefault()
        
        window.location.replace('login' + queryParams)
    })
}
